import { CONTACT_CAPTURE_FIELD_NAMES } from '../../../src/modules/contactCapture/helpers/contactCaptureSettings';
import type { FieldId, WidgetSource } from './types';
import { toSubmittablePhoneNumber } from './validations';
import { WidgetAccessDeniedError } from './errors';

/** Submit only rendered, nonempty fields, using the same names as settings.fields. */
export const submitContactCapture = async (
  source: WidgetSource,
  fields: Record<string, string>,
) => {
  if (!source.submissionUrl) {
    if (source.host.hasAttribute('data-bhi-preview')) return;
    throw new Error('The contact form submission URL is missing.');
  }

  const response = await fetch(source.submissionUrl, {
    method: 'POST',
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(Object.entries(fields)
      .filter(([, value]) => value.trim() !== '')
      .map(([name, value]) => ({
        name: CONTACT_CAPTURE_FIELD_NAMES[name as FieldId] || name,
        value: name === 'mobilePhone' ? toSubmittablePhoneNumber(value) : value.trim(),
      }))),
  });
  if (response.status === 403) throw new WidgetAccessDeniedError();
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    const message = payload?.message;
    throw new Error(typeof message === 'string' ? message
      : Array.isArray(message) && message.every(item => typeof item === 'string') ? message.join(' ')
        : 'We could not submit the form. Please try again.');
  }
};
